import { createAsyncThunk } from '@reduxjs/toolkit'
import { PAGE_URLS } from '../../../../configs/api'
import { AxiosService } from '../../../../services/api'
import { createThunkName } from '../../../../utils/createThunkname'
import {
  CreatePageDto,
  DeletePageDto,
  GetAllPagesQueryParams,
  GetAllPagesResponse,
  GetPageDescriptionByIdResponse,
  GetPageStatusByIdResponse,
  GetPageTitleByIdResponse,
  UpdatePageDescriptionDto,
  UpdatePageDto,
  UpdatePageStatusDto,
  UpdatePageTitleDto
} from './types'

const PREFIX = 'pageContent'

export const PageContentService = {
  getAllPagesAsyncThunk: createAsyncThunk(
    createThunkName(PREFIX, 'getAllPages'),
    async (queryParams: GetAllPagesQueryParams) => {
      try {
        const result = await AxiosService.get<GetAllPagesResponse>(PAGE_URLS.getAllPages, { params: queryParams })
        return result.data
      } catch (error) {
        throw error
      }
    }
  ),
  getPageTitleByIdAsyncThunk: createAsyncThunk(createThunkName(PREFIX, 'getPageTitleById'), async (pageId: string) => {
    try {
      const result = await AxiosService.get<GetPageTitleByIdResponse>(PAGE_URLS.getPageTitleById(pageId))
      return result.data
    } catch (error) {
      throw error
    }
  }),
  getPageDescriptionByIdAsyncThunk: createAsyncThunk(
    createThunkName(PREFIX, 'getPageDescriptionById'),
    async (pageId: string) => {
      try {
        const result = await AxiosService.get<GetPageDescriptionByIdResponse>(PAGE_URLS.getPageDescriptionById(pageId))
        return result.data
      } catch (error) {
        throw error
      }
    }
  ),
  getPageStatusByIdAsyncThunk: createAsyncThunk(
    createThunkName(PREFIX, 'getPageStatusById'),
    async (pageId: string) => {
      try {
        const result = await AxiosService.get<GetPageStatusByIdResponse>(PAGE_URLS.getPageStatusById(pageId))
        return result.data
      } catch (error) {
        throw error
      }
    }
  ),
  createPageAsyncThunk: createAsyncThunk(createThunkName(PREFIX, 'createPage'), async (dto: CreatePageDto) => {
    try {
      await AxiosService.post(PAGE_URLS.createPage, dto)
    } catch (error) {
      throw error
    }
  }),
  updatePageAsyncThunk: createAsyncThunk(createThunkName(PREFIX, 'updatePage'), async (dto: UpdatePageDto) => {
    try {
      await AxiosService.put(PAGE_URLS.updatePage, dto)
    } catch (error) {
      throw error
    }
  }),
  updatePageTitleAsyncThunk: createAsyncThunk(
    createThunkName(PREFIX, 'updatePageTitle'),
    async (dto: UpdatePageTitleDto) => {
      try {
        await AxiosService.put(PAGE_URLS.updatePageTitle, dto)
      } catch (error) {
        throw error
      }
    }
  ),
  updatePageDescriptionAsyncThunk: createAsyncThunk(
    createThunkName(PREFIX, 'updatePageDescription'),
    async (dto: UpdatePageDescriptionDto) => {
      try {
        await AxiosService.put(PAGE_URLS.updatePageDescription, dto)
      } catch (error) {
        throw error
      }
    }
  ),
  updatePageStatusAsyncThunk: createAsyncThunk(
    createThunkName(PREFIX, 'updatePageStatus'),
    async (dto: UpdatePageStatusDto) => {
      try {
        await AxiosService.put(PAGE_URLS.updatePageStatus, dto)
      } catch (error) {
        throw error
      }
    }
  ),
  deletePageAsyncThunk: createAsyncThunk(createThunkName(PREFIX, 'deletePage'), async (dto: DeletePageDto) => {
    try {
      await AxiosService.post(PAGE_URLS.deletePage, dto)
    } catch (error) {
      throw error
    }
  })
}
